// extracted by mini-css-extract-plugin
module.exports = {"LOGO":"logo-module--LOGO--2lxgL"};